type GLOBAL_BOOTSTRAP_DATA_TYPE = {
  clientGUID: string
}

declare interface pclnWindow {
      GLOBAL_BOOTSTRAP_DATA: GLOBAL_BOOTSTRAP_DATA_TYPE
    }


const getCguid = (): string => {
  return (window as unknown as pclnWindow)?.GLOBAL_BOOTSTRAP_DATA?.clientGUID ?? ''
}

export default getCguid
